<markant-platform-guided-tour-wrapper
  #guidedTourWrapper
  [guidedTourSteps]="steps"
  [onBack]="backButtonCallback"
  [onNext]="nextButtonCallback"
  [currentStep]="currentStep"
  [enableClickThrough]="enableClickThrough"
></markant-platform-guided-tour-wrapper>

@if (showHighlightDialog$ | async) {
  <markant-platform-guided-tour-highlight-dialog
    targetId="my-services-tour-highlight-dialog"
    textBaseKey="guidedTour.tours.guided-tour-oa-admin-area.section4"
    [dialogPosition]="dialogConfig.position"
    [currentStep]="currentStep"
    [stepsWithPreviousButton]="STEPS_WITH_PREVIOUS_BUTTON"
    (next)="nextTarget()"
    (previous)="previousTarget()"
  >
    @if (STEPS_BOOKING_TABLE_DEMO | arrayIncludes: currentStep) {
      <markant-platform-bookings-table-demo
        [currentStep]="currentStep"
      ></markant-platform-bookings-table-demo>
    }

    @if (STEPS_MANAGER_VIEW_DEMO | arrayIncludes: currentStep) {
      <markant-platform-management-view-demo
        [currentStep]="currentStep"
      ></markant-platform-management-view-demo>
    }
  </markant-platform-guided-tour-highlight-dialog>
}
